import { signupFormSplitWithMetrics } from "@redotech/redo-marketing-common/signup-form/signup-form";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getSignupFormSplits = {
  name: "getSignupFormSplits" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.array(signupFormSplitWithMetrics),
};
